import {createSlice} from '@reduxjs/toolkit';
import {httpGet} from '../../../util/Rest';
import {CLIENT} from '../../../constants/MicroServiceConstants';

const initialData = {
  clientInfoData: {},
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  departmentInfoData: {},
  contactData: [],
};

const slice = createSlice({
  name: 'spouse',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    getClientInfo: (state, action) => {
      state.clientInfoData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getClientInfoData: (state, action) => {
      state.departmentInfoData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetData: (state) => {
      state.clientInfoData = {};
      state.departmentInfoData = {};
    },
  },
});

export default slice.reducer;

// Actions

const {getClientInfo, fetchStart, fetchError, resetData, getClientInfoData} = slice.actions;

export const fetchClientInformation = (clientNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`${CLIENT}/find/general/${clientNumber}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getClientInfo(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchClientInformationData = (clientNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`businessclient/find/serviceclient/${clientNumber}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getClientInfoData(data.response));
        } else {
          dispatch(fetchError(data.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const resetClientInformation = () => {
  return (dispatch) => {
    dispatch(resetData());
  };
};
